module.exports = __webpack_public_path__ + "img/employees.94096129.svg";